<template>
  <div class="app-container">
    <!-- 顶部导航栏 -->
    <header class="app-header" v-if="isLoggedIn">
      <div class="header-content">
        <!-- 返回主页按钮 -->
        <button v-show="!showButtons" class="back-button" @click="goHome">
          <span class="button-text">返回主页</span>
        </button>
        <!-- 右上角容器 -->
        <div class="right-corner">
          <!-- 用户名 -->
          <span class="username">{{ username }}</span>
          <!-- 登出按钮 -->
          <button class="logout-btn" @click="handleLogout">
            <span class="button-text">登出</span>
          </button>
        </div>
      </div>
    </header>
    <StarsRomantic :style="{ zIndex: -1 }" />
    <!-- 主要内容区 -->
    <main class="main-content">
      <!-- 登录组件 -->
      <Login v-if="!isLoggedIn" @login-success="handleLoginSuccess" />

      <!-- 登录后的功能区 -->
      <div v-else>
        <!-- 标题 DOM -->
        <div class="title-container">
          <h1 class="main-title" v-show="showButtons">Maply.NetTool</h1>
        </div>
        <!-- 功能按钮区 -->
        <div class="button-grid" v-show="showButtons">
          <button
            v-for="button in buttons"
            :key="button.text"
            class="app-button"
            @click="handleButtonClick(button.component)"
          >
            {{ button.text }}
          </button>
        </div>

        <!-- 功能组件显示区 -->
        <div class="component-container">
          <component
            :is="activeComponent"
            v-show="!!activeComponent"
            @show-home="goHome"
          />
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { mapState, mapActions } from "vuex";
import Login from "./components/UserLogin.vue";
import { StarsRomantic } from "./components";
import { components, buttons } from "./utils";
export default defineComponent({
  name: "MainIndex",

  components: {
    Login,
    StarsRomantic,
  },

  data() {
    return {
      showButtons: true,
      activeComponent: null,
      components: [...components],
      buttons: [...buttons],
    };
  },

  computed: {
    ...mapState(["username", "isLoggedIn"]),
  },

  methods: {
    ...mapActions(["logoutUser"]),

    handleLoginSuccess() {
      this.showButtons = true;
      this.goHome();
    },

    handleButtonClick(component) {
      this.activeComponent = component;
      this.showButtons = false;
    },

    goHome() {
      this.activeComponent = null;
      this.showButtons = true;
    },

    async handleLogout() {
      await this.logoutUser();
      this.goHome();
    },
  },

  created() {
    const username = localStorage.getItem("username");
    if (!username) {
      this.goHome();
    }
  },
});
</script>

<style scoped>
/* 基础容器样式 */
.app-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: auto;
  overflow-x: hidden; /* 防止横向滚动条 */
}

/* 头部样式 */
.app-header {
  width: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 2;
  padding: 10px 20px;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* 返回主页按钮 */
.back-button {
  position: fixed;
  top: 10px;
  left: 20px;
  padding: 8px 16px;
  background-color: #2196f3;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;
  z-index: 3;
}

.back-button:hover {
  background-color: #1976d2;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(33, 150, 243, 0.3);
}

/* 右上角容器 */
.right-corner {
  position: fixed;
  top: 10px;
  right: 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  z-index: 3;
}

/* 用户名 */
.username {
  color: goldenrod;
  font-size: 16px;
  line-height: 1;
  padding-top: 20px;
}

/* 登出按钮 */
.logout-btn {
  padding: 8px 16px;
  background-color: #ff4757;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;
}

.logout-btn:hover {
  background-color: #ff6b81;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(255, 71, 87, 0.3);
}

/* 主要内容区域 */
.main-content {
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;
  padding-top: 80px; /* 为固定按钮留出空间 */
}

/* 标题容器样式 */
.title-container {
  text-align: center;
  margin-bottom: 30px;
}

/* 主标题样式 */
.main-title {
  font-size: 24px;
  font-weight: bold;
  color: navajowhite;
  margin: 0;
  padding: 0;
}

/* 按钮网格 */
.button-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  max-width: 800px;
  margin: 20px auto;
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
}

/* 组件容器 */
.component-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;
  max-width: 800px;
  margin: 0 auto;
  width: 100%;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* 按钮样式 */
.app-button {
  padding: 15px 25px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.3s ease;
  width: 100%;
}

.app-button:hover {
  background-color: #45a049;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
  .main-title {
    font-size: 20px;
  }

  .back-button {
    top: 8px;
    left: 10px;
    padding: 6px 12px;
    font-size: 12px;
  }

  .right-corner {
    top: 8px;
    right: 10px;
    gap: 8px;
  }

  .username {
    font-size: 14px;
  }

  .logout-btn {
    padding: 6px 12px;
    font-size: 12px;
  }

  .main-content {
    padding: 10px;
    padding-top: 70px;
  }

  .button-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 15px;
    padding: 0 10px;
  }

  .component-container {
    padding: 15px;
  }

  .app-button {
    padding: 12px 20px;
    font-size: 14px;
  }
}

@media screen and (max-width: 480px) {
  .main-title {
    font-size: 18px;
  }

  .back-button {
    top: 5px;
    left: 5px;
    padding: 5px 10px;
    font-size: 11px;
  }

  .right-corner {
    top: 5px;
    right: 5px;
    gap: 5px;
  }

  .username {
    font-size: 12px;
  }

  .logout-btn {
    padding: 5px 10px;
    font-size: 11px;
  }

  .main-content {
    padding: 8px;
    padding-top: 60px;
  }

  .button-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    padding: 0 8px;
  }

  .component-container {
    padding: 0 8px;
  }

  .app-button {
    padding: 10px 15px;
    font-size: 12px;
  }
}
</style>
